export default __webpack_public_path__ + "static/384-1f77c521e50734c396554c2218397bdf.gif";